import { render, staticRenderFns } from "./NewIntervenantSidebar.vue?vue&type=template&id=4271d8f2&scoped=true&"
import script from "./NewIntervenantSidebar.vue?vue&type=script&lang=js&"
export * from "./NewIntervenantSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271d8f2",
  null
  
)

export default component.exports